var render = function render(){var _vm=this,_c=_vm._self._c;return _c('additional-information',{attrs:{"data":_vm.data,"currency":_vm.currency}})
}
var staticRenderFns = []

export { render, staticRenderFns }